import { render } from "./vcouponedit.vue?vue&type=template&id=e5f8c034&scoped=true"
import script from "./vcouponedit.vue?vue&type=script&lang=js"
export * from "./vcouponedit.vue?vue&type=script&lang=js"

import "./vcouponedit.vue?vue&type=style&index=0&id=e5f8c034&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5f8c034"]])

export default __exports__